module.exports = __webpack_public_path__ + "static/img/fish40.bcaa43a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/jiejifish/fish40.png
// module id = G1xP
// module chunks = 0